import React from 'react';
import InputGroup from '../../../../components/form/InputGroup';
import PermitRequestType from './permit-types/PermitRequestType';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import SectionTitle from '../SectionTitle';
import FormSection from './FormSection';
import PermitTypeSelect from '../../../../components/form/selects/PermitTypeSelect';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../hooks/useTags';
import formErrorsLang from '../../../../data/lang/form-errors.lang';

function PersonDetailsFormSection() {

    const { handleChange, handleChangeFile, Formik } = usePermitRequestContext();
    const { errors, values, touched, handleBlur } = Formik;
    const personDetailsValues = values.personDetails;
    const personDetailsErrors = errors.personDetails ? errors.personDetails : {};
    const personDetailsTouched = touched.personDetails ? touched.personDetails : {};

    const generateTag = useTags();

    const sectionTitle = generateTag(addRequestPageLang, 'form.personal-details-section.title');
    const privateNameLabel = generateTag(addRequestPageLang, 'form.personal-details-section.privateNameLabel');
    const familyNameLabel = generateTag(addRequestPageLang, 'form.personal-details-section.familyNameLabel');
    const idLabel = generateTag(addRequestPageLang, 'form.personal-details-section.idLabel');
    const personFWithAddinalFileLabel = generateTag(addRequestPageLang, 'form.personal-details-section.personFileLabelWithAdditionalFile');
    const personFLabel = generateTag(addRequestPageLang, 'form.personal-details-section.personFileLabel');

    const personFileLabel = personDetailsValues.hasAdditionalPersonIdFile
        ? personFWithAddinalFileLabel
        : personFLabel;
    const additionalPersonIdFileLabel = generateTag(addRequestPageLang, 'form.personal-details-section.additionalPersonIdFileLabel');

    const privateNameTouched = personDetailsTouched.privateName;
    const privateNameError = personDetailsErrors.privateName;
    const familyNameTouched = personDetailsTouched.familyName;
    const familyNameError = personDetailsErrors.familyName;
    const idTouched = personDetailsTouched.id;
    const idError = personDetailsErrors.id;
    const scanIdTouched = personDetailsTouched.scanId;
    const scanIdError = personDetailsErrors.scanId;
    const additionalPersonIdFileTouched = personDetailsTouched.additionalPersonIdFile;
    const additionalPersonIdFileError = personDetailsErrors.additionalPersonIdFile;

    const privateNameMsg = generateTag(formErrorsLang, privateNameError && privateNameTouched ? privateNameError : '');
    const familyNameMsg = generateTag(formErrorsLang, familyNameError && familyNameTouched ? familyNameError : '');
    const idMsg = generateTag(formErrorsLang, idError && idTouched ? idError : '');
    
    // @ts-ignore
    const scanIdMsg = generateTag(formErrorsLang, scanIdError && scanIdTouched ? scanIdError : '');
    // @ts-ignore
    const additionalPersonIdFileMsg = generateTag(formErrorsLang, additionalPersonIdFileError && additionalPersonIdFileTouched ? additionalPersonIdFileError : '');

    return (
        <FormSection>
            <SectionTitle title={sectionTitle} />
            <div className='row'>
                <div className='col-6 col-lg-4 col-lg-3'>
                    <InputGroup
                        type={'text'}
                        name={'personDetails.privateName'}
                        label={privateNameLabel}
                        value={personDetailsValues.privateName}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={privateNameMsg}
                    />
                </div>
                <div className='col-6 col-lg-4 col-lg-3'>
                    <InputGroup
                        type={'text'}
                        name={'personDetails.familyName'}
                        label={familyNameLabel}
                        value={personDetailsValues.familyName}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        errorMsg={familyNameMsg}
                        isRequired={true}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col-md-6 col-lg-4'>
                    <InputGroup
                        name={'personDetails.id'}
                        label={idLabel}
                        type='number'
                        value={personDetailsValues.id}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={idMsg}
                    />
                </div>
                <div className='col-md-6 col-lg-4'>
                    <InputGroup
                        type={'file'}
                        name={'personDetails.scanId'}
                        label={personFileLabel}
                        handleBlur={handleBlur}
                        handleChange={(event) => {
                            handleChangeFile('personDetails.scanId', 'scanId', event.currentTarget.files[0]);
                        }}
                        isRequired={true}
                        errorMsg={scanIdMsg}
                    />
                </div>
                {personDetailsValues.hasAdditionalPersonIdFile ? (
                    <div className='col-md-6 col-lg-4'>
                        <InputGroup
                            type={'file'}
                            name={'personDetails.additionalPersonIdFile'}
                            label={additionalPersonIdFileLabel}
                            handleBlur={handleBlur}
                            handleChange={(event) => {
                                handleChangeFile(
                                    'personDetails.additionalPersonIdFile',
                                    'additionalPersonIdFile',
                                    event.currentTarget.files[0]
                                );
                            }}
                            isRequired={true}
                            errorMsg={additionalPersonIdFileMsg}
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>

            <PermitRequestType />

            <div className='row'>
                <div className='col-2'>
                    <PermitTypeSelect
                        permitType={values.permitType}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                    />
                </div>
            </div>
        </FormSection>
    );
}


export default PersonDetailsFormSection;